import React from 'react'
import { Mark } from './SignInShell.styles'

/** The small Orbit lockup at the foot of the card's hero panel. */
const OrbitMark: React.FC = () => (
	<Mark>
		<img src="/orbit-icon.svg" alt="" />
		<b>Orbit</b>
	</Mark>
)

export default OrbitMark
